import modelFieldMessages from './modelFieldMessages';

class LineSettings {
  static fields = {
    id: {
      key: 'id',
      type: 'string',
      title: modelFieldMessages.id,
      editable: false
    },
    key: {
      key: 'key',
      type: 'string',
      title: modelFieldMessages.key
    },
    value: {
      key: 'value',
      type: 'string',
      title: modelFieldMessages.value
    },
    machine: {
      key: 'machine',
      type: 'string',
      title: modelFieldMessages.machineNameLineSetting
    }
  };

  static actions = {
    deleteLineSetting: {
      key: 'delete',
      type: 'delete',
      dispatch: 'deleteLineSetting',
      modal: {
        modal: true,
        buttonText: 'deleteLineSetting',
        key: 'deleteLineSetting',
        action: 'deleteLineSetting',
        actionData: {
          target: 'backend',
          source: 'orders/linesetting/',
          url: '/api/v1/orders/linesetting/remove_line_setting/',
          items: 'selected',
          callType: 'POST'
        }
      }
    },
    editLineSetting: {
      key: 'edit',
      type: 'edit',
      identifier: 'editLineSetting',
      configuration: {
        model: 'linesetting',
        url: '/api/v1/orders/linesetting/'
      }
    }
  };
}

export default LineSettings;
